import { bindTypesToActions } from '@src/utils/redux_utils';
import { getDate } from '@src/utils/date';

export const types = {
    //saga actions:
    GetPlans: 'PLANS_GET_PLANS',
    //reducer actions:
    SetPlans: 'PLANS_SET_PLANS',
    SetUserplan: 'PLANS_SET_USERPLAN'
}

const plansActions = bindTypesToActions(types);


let initialState = {
    plans : [],
    userPlan: null 
}

const plansReducer = (state = initialState, { type, payload } ) => {
    switch (type) {
    
        case types.SetPlans: // set plans. 
            const  { plans } = payload ?? {} ;

            return Array.isArray( plans ) ? { ...state, plans }: state ;
        
        case types.SetUserplan: // update a user subscribed plan.
    
            const { userPlan } = payload ?? {} ;

            if( !userPlan?.planid  ||  ( new Date() > getDate( userPlan.expirydate ) ) ) return state ;
            
            return {
                ...state,
                userPlan
            }   
        case 'LOG_OUT_ALL': //manage logout
            return initialState ;

        default: return state;
    }
}


export {
 types as plansTypes,
 plansReducer,
 plansActions
}